module.exports = __webpack_public_path__ + "l.no2.b521c8d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/l.no2.jpg
// module id = yIOW
// module chunks = 0